//@ts-check
var texts = require("./texts")

module.exports = {
  buildABIFunctionTitle: (name, purpose, standardName) =>
    texts.test_abi_function_title
      .replace(/{name}/g, name)
      .replace(/{standard_name}/g, standardName)
      .replace(/{purpose}/g, purpose),

  buildABIFunctionDescription: (name, purpose, standardName) =>
    texts.test_abi_function_description
      .replace(/{name}/g, name)
      .replace(/{standard_name}/g, standardName)
      .replace(/{purpose}/g, purpose),

  buildERC20EventTitle: (name, purpose) =>
    texts.test_abi_erc20_event_title
      .replace(/{name}/g, name)
      .replace(/{purpose}/g, purpose)
      .replace(/{standard_name}/g, "the ERC-20 standard"),

  buildERC20EventDescription: (name, purpose) =>
    texts.test_abi_erc20_event_description
      .replace(/{name}/g, name)
      .replace(/{purpose}/g, purpose)
      .replace(/{standard_name}/g, "the ERC-20 standard"),

  buildRecommendationForOpenSourceFunction: name =>
    texts.recommendationSwitchToOpenSource.replace(/{name}/g, name),
}
